const LINKS = {
  recon: {
    development: {
      reconAuthServiceUrl: 'https://localhost:8080/business/commercial/v1/reconciliation/',
    },
    e1: {
      reconPortalLoginUrl: 'https://reconciliationportal-dev.americanexpress.com/mlurLogin.jsp',
      reconPortalAppSelectionUrl: 'https://reconciliationportal-dev.americanexpress.com/select-application',
      targetDomainUrl: 'https://commercial-recon-dev.americanexpress.com/',
      reconPortalAdvUrl: 'https://reconciliationportal-dev.americanexpress.com',
      reconAuthServiceUrl: 'https://apigw-dev.americanexpress.com/business/commercial/v1/reconciliation/',
    },
    e2: {
      reconPortalLoginUrl: 'https://reconciliationportal-qa.americanexpress.com/mlurLogin.jsp',
      reconPortalAppSelectionUrl: 'https://reconciliationportal-qa.americanexpress.com/select-application',
      targetDomainUrl: 'https://commercial-recon-qa.americanexpress.com/',
      reconPortalAdvUrl: 'https://reconciliationportal-qa.americanexpress.com',
      reconAuthServiceUrl: 'https://apigw-qa.americanexpress.com/business/commercial/v1/reconciliation/',
    },
    e3: {
      reconPortalLoginUrl: 'https://reconciliationportal.americanexpress.com/mlurLogin.jsp',
      reconPortalAppSelectionUrl: 'https://reconciliationportal.americanexpress.com/select-application',
      targetDomainUrl: 'https://commercial-recon.americanexpress.com/',
      reconPortalAdvUrl: 'https://reconciliationportal.americanexpress.com',
      reconAuthServiceUrl: 'https://apigw.americanexpress.com/business/commercial/v1/reconciliation/',
    },
  },
  oneData: {
    e1: {
      enterpriseLoginUrl: 'https://identity-1-dev.americanexpress.com/en-us/account/blue/login?option=reconciliation&target=https://reconciliationportal-dev.americanexpress.com/select-application',
      enterpriseHomepageUrl: 'https://identity-1-dev.americanexpress.com',
    },
    e2: {
      enterpriseLoginUrl: 'https://identity-1-qa.americanexpress.com/en-us/account/blue/login?option=reconciliation&target=https://reconciliationportal-qa.americanexpress.com/select-application',
      enterpriseHomepageUrl: 'https://identity-1-qa.americanexpress.com',
    },
    e3: {
      enterpriseLoginUrl: 'https://www.americanexpress.com/en-us/account/blue/login?option=reconciliation&target=https://reconciliationportal.americanexpress.com/select-application',
      enterpriseHomepageUrl: 'https://www.americanexpress.com',
    },
  },
};
const getLinks = (app, env) => {
  if (app && env) {
    if (LINKS[app]) {
      return LINKS[app][env] ? LINKS[app][env] : {};
    }
    return {};
  }
  return {};
};

export default getLinks;
